export var StandardLevel;
(function (StandardLevel) {
    StandardLevel[StandardLevel["NoLevel"] = 0] = "NoLevel";
    StandardLevel[StandardLevel["One"] = 1] = "One";
    StandardLevel[StandardLevel["Two"] = 2] = "Two";
    StandardLevel[StandardLevel["Three"] = 3] = "Three";
    StandardLevel[StandardLevel["Four"] = 4] = "Four";
    StandardLevel[StandardLevel["Five"] = 5] = "Five";
    StandardLevel[StandardLevel["Six"] = 6] = "Six";
    StandardLevel[StandardLevel["Seven"] = 7] = "Seven";
})(StandardLevel || (StandardLevel = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhbmRhcmQtbGV2ZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdGFuZGFyZC1sZXZlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxhQVNYO0FBVEQsV0FBWSxhQUFhO0lBQ3JCLHVEQUFXLENBQUE7SUFDWCwrQ0FBTyxDQUFBO0lBQ1AsK0NBQU8sQ0FBQTtJQUNQLG1EQUFTLENBQUE7SUFDVCxpREFBUSxDQUFBO0lBQ1IsaURBQVEsQ0FBQTtJQUNSLCtDQUFPLENBQUE7SUFDUCxtREFBUyxDQUFBO0FBQ2IsQ0FBQyxFQVRXLGFBQWEsS0FBYixhQUFhLFFBU3hCIn0=